import { Component, OnInit, Input, ViewChild, OnChanges } from "@angular/core";

import { Output, EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  faGrid,
  faList,
  faArrowDownAZ,
  faArrowUpZA,
} from "@fortawesome/pro-light-svg-icons";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import {
  faCertificate,
  faShieldKeyhole,
} from "@fortawesome/pro-light-svg-icons";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { environment } from "../../../../environments/environment";

import { SelectionModel } from "@angular/cdk/collections";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { debounceTime } from "rxjs/operators";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

@Component({
    selector: "app-publish-canvas-list",
    templateUrl: "./canvas-list.component.html",
    styleUrls: ["./canvas-list.component.scss"],
    standalone: false
})
export class PublishCanvasListComponent implements OnInit, OnChanges {
  public canvasForm!: UntypedFormGroup;

  constructor(
    private canvasService: CanvasService,
    public commonService: CommonService,
    private fb: UntypedFormBuilder
  ) {
    this.publishListener = this.canvasService
      .listenForPublish()
      .subscribe(() => {
        this.outputSelection(this.selection.selected);
      });
  }
  @Input() canvasType?: any;
  @Input() categories?: any;
  @Input() toggleRefresh?: any;
  @Input() selections?: any;
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  @Output() selectionList = new EventEmitter<string>();

  public canvas_listing: any[] = [];
  private publishListener: any;

  public p: number = 1;
  public breakpoint: number = 4;
  public display_data: string = "list";
  public status: boolean = true;
  public filtered_reports: any;
  public sort_view_asc: boolean = true;
  public pagination: any;

  public totalCanvasObjectResults: number = 0;

  public canvasListLoaded = false;

  faList = faList;
  faGrid = faGrid;

  faSearch = faSearch;
  faCertificate = faCertificate;
  faShieldKeyhole = faShieldKeyhole;
  faArrowDownAZ = faArrowDownAZ;
  faArrowUpZA = faArrowUpZA;
  public direction = false;

  public fieldForm!: UntypedFormGroup;
  public error: string = "";
  public page: number = 1;
  public count: number = 20000;
  public dataFields: any[] = [];
  public canvasFields: any[] = [];
  public fieldItem: any;
  showData = false;
  displayedColumns: string[] = [
    "select",
    "name",
    "category",
    "access",
    "published",
    "modified",
  ];
  dataSetListing: any;
  existingDataFields: any;
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  filterValues: any = {};
  loading = false;
  timer: any;
  firstTime = true;
  public data: any = [];

  outputSelection(value: any) {
    this.selectionList.emit(value);
  }

  getAllCanvasObjects() {
    this.canvasService
      .getAllPublishCanvasObjects(5000, this.canvasType)
      .subscribe((data: any) => {
        this.canvasListLoaded = true;
        this.data = data.data;

        //console.log(data);
        this.dataSource = new MatTableDataSource(<any>data.data);
        this.selection = new SelectionModel<any>(true, []);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.showData = true;
      });
  }

  formatDate(time: string) {
    const displaydTIme = dayjs(time).fromNow();
    return displaydTIme;
  }

  formatModified(time: string) {
    const displaydTIme = dayjs(time).format("MMM D YYYY - h:MM A");
    return displaydTIme;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  getSecurityGroups(canvasGroups: any) {
    let groups = "";
    canvasGroups.data.forEach((item: any) => {
      if (item.edit == 1) {
        groups += item.name + ", ";
      }
    });
    groups = groups.substring(0, groups.length - 2);
    return groups;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row: any) => this.selection.select(row));
  }

  logSelection() {
    this.selection.selected.forEach((s: any) => console.log(s.id));
  }
  applyFilter(filter: any) {
    const filterValue = (filter.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnChanges() {
    if (this.toggleRefresh) {
      this.updatePublishDate();
    }
  }

  updatePublishDate() {
    const nowDate = new Date().toISOString();
    this.toggleRefresh.published.forEach((item: any) => {
      const entries = Object.entries(item);
      const id = parseInt(entries[0][0].toString());
      const success = entries[0][1];
      if (success) {
        let index: number = this.data.findIndex((d: any) => d.id === id);
        this.data[index].created_at = nowDate;
      }
    });

    this.dataSource = new MatTableDataSource(<any>this.data);
    this.selection = new SelectionModel<any>(true, []);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.selection = new SelectionModel<Element>(true, []);
  }
  ngOnInit(): void {
    this.canvasForm = this.fb.group({
      searchTerm: new UntypedFormControl(),
    });
    this.getAllCanvasObjects();
  }
}
